import type { ReactNode } from 'react';
import { Paper } from '@mantine/core';
import { layoutTokens } from '../tokens/layoutTokens';
import classes from './DataTableShell.module.css';

export function DataTableShell({
  children,
  fillHeight = false,
}: {
  children: ReactNode;
  fillHeight?: boolean;
}) {
  return (
    <Paper
      radius="lg"
      withBorder
      shadow="xs"
      className={fillHeight ? classes.fill : undefined}
      style={{
        overflow: 'hidden',
        borderRadius: layoutTokens.tableRadius,
        minWidth: 0,
        maxWidth: '100%',
        width: '100%',
      }}
    >
      {children}
    </Paper>
  );
}
